import React from 'react';
import { get } from 'lodash';
import { FaCheck } from 'react-icons/fa';
import { Collection } from 'core/model';
import { Flex, Card, CopyText, Text, Heading, Icon } from 'core/components';
import { VirtualizedTable } from 'core/components/table';
import { ENTITY_TYPES } from 'shared/hybrid/constants';
import CloudIcon from 'app/views/hybrid/maps/components/CloudIcon';

const { VPC, SUBNET, FIREWALL, VPC_ENDPOINT } = ENTITY_TYPES.get('aws');

const AwsFirewallAttachments = (props) => {
  const { nodeData, topology } = props;

  const { type, id, FirewallId = null } = nodeData;

  let firewallId = FirewallId;
  if (type === FIREWALL) {
    firewallId = id;
  }

  if (!firewallId) {
    return null;
  }

  const firewall = get(topology.Entities, `${[FIREWALL]}.${firewallId}`);

  if (!firewall) {
    return null;
  }

  const { FirewallStatus } = firewall;

  const firewallAttachments = new Collection(
    Object.keys(FirewallStatus?.SyncStates ?? {}).map((az) => {
      const azAttachment = FirewallStatus.SyncStates[az].Attachment;
      const subnetId = azAttachment.SubnetId;
      const status = azAttachment.Status;
      const endpointId = azAttachment.EndpointId;

      const subnet = get(topology.Entities, `${[SUBNET]}.${subnetId}`);
      const vpc = get(topology.Entities, `${[VPC]}.${subnet.VpcId}`);
      const vpcEndpoint = get(topology.Entities, `${[VPC_ENDPOINT]}.${endpointId}`);

      return {
        az,
        vpc,
        subnet,
        status,
        vpcEndpoint
      };
    })
  );

  const columns = [
    {
      label: 'Subnet',
      name: 'subnet',
      renderer: ({ value }) => (
        <Flex flexDirection="column" alignItems="center">
          <Text>{value?.Name}</Text>
          <CopyText key={value?.id} text={value?.id} textProps={{ fontWeight: 'bold', muted: true }} />
        </Flex>
      )
    },
    {
      label: 'Vpc Endpoint',
      name: 'vpcEndpoint',
      renderer: ({ value }) => (
        <Flex flexDirection="column" alignItems="center">
          <Text>{value?.Name}</Text>
          <CopyText key={value?.id} text={value?.id} textProps={{ fontWeight: 'bold', muted: true }} />
        </Flex>
      )
    },
    {
      label: 'Status',
      name: 'status',
      width: 50,
      renderer: ({ value }) =>
        value === 'READY' ? (
          <Icon icon={FaCheck} mx={1} intend="success" />
        ) : (
          <Icon icon="error" color="danger" mx={1} />
        )
    }
  ];

  return (
    <Flex flexDirection="column" flex={1} gap={2}>
      <Heading level={4} alignSelf="flex-start">
        <CloudIcon cloudProvider="aws" entity={SUBNET} width={24} height={24} style={{ marginRight: '8px' }} />
        Firewall Attachments
      </Heading>
      <Card height="100%">
        <VirtualizedTable
          style={{ height: 300 }}
          collection={firewallAttachments}
          columns={columns}
          selectOnRowClick={false}
          isCollapsed
          flexed
        />
      </Card>
    </Flex>
  );
};

export default AwsFirewallAttachments;
